import React, {Component} from 'react'
import FontIcon from '../../atoms/FontIcon'
import css from './style.module.css'

class SprintaTips extends Component {
    render() {

        const { style, className, ...props } = this.props

        return(
            <div className={css.tips} style={{ ...style }}>
                <div style={{padding: '0 30px 0 0' }}>
                    <FontIcon name='admin_tip' size={60} />
                </div>
                <div style={{ float: 'left' }}>
                    <h3 className={css.title}><span>SPRINTA</span> Tips</h3>
                    <p className={css.text}>{props.children}</p>
                </div>
            </div>
        );
    }
}

export default SprintaTips


// WEBPACK FOOTER //
// ./src/SPRINTA/molecules/SprintaTips/index.js